import React from "react";
import { Quote, Star } from "lucide-react";
import { SITE } from "@/lib/site";
import { useContent } from "@/lib/content";

export default function Placements() {
  const { content } = useContent();
  const p = content.placements || {};
  const stories = p.stories || [];
  const bg = p.bg_image_url || SITE.media.classroomB;

  return (
    <section id="placements" data-testid="placements-section" className="bg-[#002570] text-white relative overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0 opacity-[0.18]" style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundPosition: "center" }} />
      <div className="absolute inset-0 bg-gradient-to-br from-[#002570] via-[#002570]/95 to-[#001a52]/95" />
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(ellipse_at_top_right,_#73c3ff,_transparent_60%)]" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <p className="font-inter text-sm font-semibold tracking-[0.18em] uppercase text-[#73c3ff]">{p.eyebrow || "Success Stories"}</p>
          <h2 className="mt-3 font-rubik text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-tight text-balance">
            {p.headline_pre || "Real students."} <span className="text-[#73c3ff]">{p.headline_emphasis || "Real placements."}</span>
          </h2>
          <p className="mt-4 font-inter text-base md:text-lg text-white/80">{p.body || "Every story below started with a free consultation. The next one could be yours."}</p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-5">
          {stories.map((s, i) => (
            <div key={i} data-testid={`story-card-${i}`} className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-7 hover:bg-white/[0.08] transition-all hover:-translate-y-1 duration-300">
              <Quote className="w-8 h-8 text-[#73c3ff] mb-4" />
              <p className="font-inter text-base text-white/90 leading-relaxed">"{s.quote}"</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <p className="font-rubik text-base font-semibold">{s.name}</p>
                  <p className="font-inter text-sm text-white/70">
                    {s.course} · <span className="text-[#73c3ff]">{s.company}</span>
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {[...Array(s.rating || 5)].map((_, idx) => (
                    <Star key={idx} className="w-4 h-4 fill-[#73c3ff] text-[#73c3ff]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
